export default "__VITE_ASSET__DSZJ5iHm__"